module.exports = __webpack_public_path__ + "static/img/1067_big.b3476cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1067_big.png
// module id = doEh
// module chunks = 1